import { ref, onMounted, onUnmounted } from 'vue'

export const useParallax = (options = { 
  scrollSpeed: 0.5,
  mouseIntensity: 0.1,
  enableMouse: true
}) => {
  const element = ref<HTMLElement | null>(null)
  const scrollOffset = ref(0)
  const mouseOffsetX = ref(0)
  const mouseOffsetY = ref(0)

  const handleScroll = () => {
    if (!element.value) return

    const rect = element.value.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const elementTop = rect.top + scrollTop
    const windowHeight = window.innerHeight
    const elementHeight = rect.height

    // Calculate how far the element is from the center of the viewport
    const distanceFromCenter = (scrollTop + windowHeight / 2) - (elementTop + elementHeight / 2)
    
    // Apply scroll parallax effect
    scrollOffset.value = distanceFromCenter * options.scrollSpeed
  }

  const handleMouseMove = (event: MouseEvent) => {
    if (!element.value || !options.enableMouse) return

    const rect = element.value.getBoundingClientRect()
    const centerX = rect.left + rect.width / 2
    const centerY = rect.top + rect.height / 2

    // Calculate distance from mouse to element center
    const distanceX = event.clientX - centerX
    const distanceY = event.clientY - centerY

    // Apply mouse parallax effect
    mouseOffsetX.value = distanceX * options.mouseIntensity
    mouseOffsetY.value = distanceY * options.mouseIntensity
  }

  const setElement = (el: HTMLElement) => {
    element.value = el
  }

  onMounted(() => {
    window.addEventListener('scroll', handleScroll)
    if (options.enableMouse) {
      window.addEventListener('mousemove', handleMouseMove)
    }
    handleScroll() // Initial position
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
    if (options.enableMouse) {
      window.removeEventListener('mousemove', handleMouseMove)
    }
  })

  return {
    scrollOffset,
    mouseOffsetX,
    mouseOffsetY,
    setElement
  }
} 